import { useCallback, useEffect, useState } from "react";

import { getServiceOrders, updateInvoiceStatus } from "services/serviceOrders/rest";
import { InvoiceServiceOrderDto, ServiceOrderDto } from "services/serviceOrders/restModels";
import { UseNotificationSnackbarReturn } from "shared/ui/NotificationSnackbar/useNotificationSnackbar";

export const useServiceOrders = (
    branchId: number,
    notify: UseNotificationSnackbarReturn,
    // Оплата счёта продлевает тариф на бэке — карточку надо перечитать.
    onInvoicePaid: () => void
) => {
    const [orders, setOrders] = useState<ServiceOrderDto[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [savingInvoiceId, setSavingInvoiceId] = useState<string | null>(null);

    const loadOrders = useCallback(async () => {
        setLoading(true);

        const response = await getServiceOrders(branchId);

        setOrders(response || []);
        setError(response === null);
        setLoading(false);
    }, [branchId]);

    useEffect(() => {
        loadOrders();
    }, [loadOrders]);

    const replaceInvoice = (updated: InvoiceServiceOrderDto) =>
        setOrders((current) =>
            current.map((order) =>
                order.type === "Invoice" && order.invoiceId === updated.invoiceId ? updated : order
            )
        );

    const changeInvoiceStatus = async (
        invoiceId: string,
        status: "Paid" | "Cancelled",
        paidAt: number | null
    ) => {
        setSavingInvoiceId(invoiceId);

        try {
            // Ручка возвращает счёт целиком — подменяем строку на месте.
            replaceInvoice(await updateInvoiceStatus(invoiceId, { status, paidAt }));
            notify.showSuccess(status === "Paid" ? "Счёт отмечен оплаченным" : "Счёт отменён");

            if (status === "Paid") onInvoicePaid();
        } catch (caught) {
            notify.showError("Не удалось обновить статус счёта", caught);
        } finally {
            setSavingInvoiceId(null);
        }
    };

    return {
        orders,
        loading,
        error,
        savingInvoiceId,
        changeInvoiceStatus,
        replaceInvoice,
        onRetry: loadOrders,
    };
};
